import styled, { css } from "styled-components";

import { Breakpoint, screenBelow } from "../BreakPoints";
import { Align, FLEX_ALIGN, Space, SPACE } from "../LayoutTokens";

export const StyledRow = styled.div<{
  $space: Space;
  $align: Align;
  $collapse?: Breakpoint;
}>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: ${({ $align }) => FLEX_ALIGN[$align]};
  gap: ${({ $space }) => SPACE[$space]};

  ${({ $collapse }) =>
    $collapse &&
    css`
      ${screenBelow[$collapse]} {
        flex-direction: column;
        align-items: stretch;
      }
    `}
`;

StyledRow.displayName = "StyledRow";
